var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84455 20.2619C4.15273 20.2619 1 19.6874 1 17.3866C1 15.0859 4.13273 12.9619 7.84455 12.9619C11.5364 12.9619 14.6891 15.0653 14.6891 17.3661C14.6891 19.6659 11.5564 20.2619 7.84455 20.2619Z",
    stroke: "#B1B1BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83652 9.77364C10.2592 9.77364 12.2229 7.81 12.2229 5.38727C12.2229 2.96455 10.2592 1 7.83652 1C5.41379 1 3.44924 2.96455 3.44924 5.38727C3.44106 7.80182 5.39106 9.76546 7.80561 9.77364C7.81652 9.77364 7.82652 9.77364 7.83652 9.77364Z",
    stroke: "#B1B1BC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d39cc32c14baca05f0af1aa673894e2b.svg";
export { ForwardRef as ReactComponent };